import React, { useEffect, useState } from 'react';
import useDragTranslate from '../hooks/useDragTranslate';
import { getRandomWindowPosition } from '../utils/windowPositioning';
/* email window component */

const EmailWindow = ({ onClose, zIndex, onFocus }) => {
  const { elRef, onPointerDown, onPointerMove, onPointerUp } = useDragTranslate(onFocus);
  
  // Generate random position for this window
  const [windowPosition] = useState(() => getRandomWindowPosition(500, 400));
  /* drag functionality for this window */
  
  const handleFocus = () => {
    onFocus && onFocus();
    /* bring window to front when clicked */
  };

  const handleClose = () => {
    // 1) add .closing
    elRef.current?.classList.add('closing');
    /* start the close animation */

    // 2) after animation end, call onClose to unmount
    const done = () => {
      elRef.current?.removeEventListener('animationend', done);
      onClose();
    };
    elRef.current?.addEventListener('animationend', done, { once: true });
    /* wait for animation to finish then actually close */
  };

  useEffect(() => {
    // listen on the document so we can move outside the window bounds
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    /* set up drag event listeners */
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      /* clean up listeners */
    };
  }, [onPointerMove, onPointerUp]);

  return (
    <div
      ref={elRef}
      className="window"
      data-window="email"
      style={{
        display: 'block',
        width: '400px',
        zIndex: zIndex,
        position: 'fixed',
        '--tx': `${windowPosition.tx}px`,
        '--ty': `${windowPosition.ty}px`,
        // important: do not set left/top/transform here; css handles it.
      }}
      onClick={handleFocus}
    >
      <div className="title-bar draggable" onPointerDown={onPointerDown}>
        <div className="title-bar-text">Contact Info - notepad.exe</div>
        <div className="title-bar-controls">
          <button aria-label="Close" onClick={handleClose}></button>
        </div>
      </div>
      {/* window title bar with close button */}
      <div className="window-body">
        <div style={{ 
          fontFamily: 'Courier New, monospace', 
          fontSize: '12px', 
          lineHeight: '1.4',
          whiteSpace: 'pre-wrap',
          padding: '8px'
        }}>
          avokaramusyan@gmail.com
        </div>
        {/* email address in monospace font like notepad */}
      </div>
    </div>
  );
};

export default EmailWindow;
